<template>
  <div class="ll-display-expand-list">
    <div class="ll-display-expand-list_title-wrap">
      <i
        v-if="icon"
        class="leadingIcon"
        :class="icon"
      />
      <img
        v-if="iconImg"
        :src="iconImg"
        alt=""
        class="icon-img"
      >
      <div class="ll-display-expand-list_title">
        {{ title }}<span
          v-if="number"
          class="title-number"
        >{{ number }}</span>
        <div
          v-if="numberList.length > 0"
          class="ll-display-expand-list_title-number"
        >
          <NumberList :item-list="numberList" />
        </div>
      </div>
    </div>
    <div class="ll-display-expand-list_content">
      <p v-if="itemList.length === 0 && !isLoading">
        {{ emptyText }}
      </p>
      <LlDisplayList
        v-for="(item,itemIndex) in itemList"
        v-else
        :key="itemIndex"
        :icon-img="item.iconImg"
        :leading-icon="item.icon"
        :title="item.title"
        :leading-icon-color="item.typeColor"
        :item-list="item.list"
        non-cursor
      />
      <DotLoading v-if="isLoading" />
    </div>
  </div>
</template>
<script>
export default {
  name: "LlDisplayCollapseList",
  props: {
    openIcon: {
      type: String,
      default: "icon-chevron-down",
    },
    closeIcon: {
      type: String,
      default: "icon-chevron-up",
    },
    number: {
      type: Number,
      default: 0,
    },
    title: {
      type: String,
      default: "",
    },
    iconImg: {
      type: String,
      default: "",
    },
    icon: {
      type: String,
      default: "",
    },
    numberList: {
      type: Array,
      default() {
        return [];
      },
    },
    itemList: {
      type: Array,
      default() {
        return [];
      },
    },
    emptyText: {
      type: String,
      default: "",
    },
    isStart: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    isLoading: false,
    C_itemList: [],
  }),
  watch: {
    itemList: {
      deep: true,
      handler() {
        this.C_itemList = this.itemList;
      },
    },
  },
  mounted() {
    this.C_itemList = this.itemList;
  },
  methods: {
    $_loadingOpen() {
      this.isLoading = true;
    },
    $_loadingClose() {
      this.isLoading = false;
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/ll-display-expand-list";
</style>